import { render, staticRenderFns } from "./Slugger.vue?vue&type=template&id=4cf909df"
import script from "./Slugger.vue?vue&type=script&lang=js"
export * from "./Slugger.vue?vue&type=script&lang=js"
import style0 from "./Slugger.vue?vue&type=style&index=0&id=4cf909df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports